import { FC } from "react";
import zxcvbn from "zxcvbn-typescript";
import "./passwordStrengthMeter.css";
import { useTranslation } from "react-i18next";

interface IPasswordStrengthMeter {
    password: string;
}

const PasswordStrengthMeter: FC<IPasswordStrengthMeter> = (props: IPasswordStrengthMeter) => {
    const { t } = useTranslation();
    const testResult = zxcvbn(props.password);
    const num = (testResult.score * 100) / 4;

    const changePasswordColor = () => ({
        width: `${num}%`,
        background: funcProgressColor(),
        height: "7px",
    });

    const createPassLabel = () => {
        switch (testResult.score) {
            case 0:
                return t("general.veryWeakPass");
            case 1:
                return t("general.weakPass");
            case 2:
                return t("general.fearPass");
            case 3:
                return t("general.goodPass");
            case 4:
                return t("general.strongPass");
            default:
                return "";
        }
    };

    const funcProgressColor = () => {
        switch (testResult.score) {
            case 0:
                return "#828282";
            case 1:
                return "#EA1111";
            case 2:
                return "#FFAD00";
            case 3:
                return "#9bc158";
            case 4:
                return "#00b500";
            default:
                return "none";
        }
    };

    const renderInstructions = () => {
        return (
            <ul>
                <li>{t("general.passInstruction1")}</li>
                <li>{t("general.passInstruction2")}</li>
                <li>{t("general.passInstruction3")}</li>
                <li>{t("general.passInstruction4")}</li>
            </ul>
        );
    };

    return (
        <div style={{ display: "grid" }}>
            <div className="progress">
                <div className="progress-bar" style={changePasswordColor()}></div>
            </div>
            <span className="progress-text" style={{ color: funcProgressColor() }}>
                {createPassLabel()}
            </span>
            <div style={{ color: "#828282", fontSize: "12px", textAlign: "start" }}>{renderInstructions()}</div>
        </div>
    );
};

export default PasswordStrengthMeter;
